import { MenuItem } from 'primeng/api';
import { EClaimsGroup } from '../../../core/configurations/claims.config';
import { ROOT_ROUTES } from '../../../core/configurations/router.config';

export interface INavItem {
  label: string;
  url: ROOT_ROUTES | string;
  activeIcon: string;
  inactiveIcon: string;
  subNav: IMenuItem;
  buttons: IButtonConfig[];
  standalone?: boolean;
}

export interface IButtonConfig {
  label: string;
  url: string;
}

export enum EDateFilterType {
  period,
  monthVsMonth,
}

export interface IMenuItem extends MenuItem {
  items?: IMenuItem[];
  claimGroupName?: EClaimsGroup;
  claimName?: string;
  routerLink?: string;
  data?: IMenuItemData | null;
}

export class MenuItemModel implements IMenuItem {
  items?: IMenuItem[];
  claimGroupName: EClaimsGroup;
  claimName: string;
  label: string;
  routerLink: string;
  styleClass: string = '';
  expanded: boolean = true;
  data?: MenuItemData | null = null;

  constructor(data: IMenuItem) {
    if (data.items?.length) {
      this.items = data.items;
    }
    this.claimGroupName = data.claimGroupName ?? EClaimsGroup.none;
    this.claimName = data.claimName ?? '';
    this.label = data.label ?? '';
    this.routerLink = data.routerLink ?? '';
    this.data = new MenuItemData(data.data || null);
    this.styleClass = data.styleClass ? `${this.styleClass} ${data.styleClass}` : this.styleClass;
  }
}

export interface IMenuItemData {
  type?: string | null;
  dateFilterType?: EDateFilterType;
  showScorecardFilter?: boolean;
}

export class MenuItemData implements IMenuItemData {
  type?: string | null = null;
  dateFilterType?: EDateFilterType = EDateFilterType.period;
  showScorecardFilter?: boolean = false;

  constructor(data?: IMenuItemData | null) {
    this.type = data?.type ?? null;
    this.dateFilterType = data?.dateFilterType ?? EDateFilterType.period;
    this.showScorecardFilter = data?.showScorecardFilter ?? false;
  }
}
